export default __webpack_public_path__ + "static/provedores-ee40c4164bbf339aea6843a600f4c98e.png";